import alertBar, { alertBarResize } from '../__header/alertBar';
import MegaMenu from '../__header/MegaMenu';
import headerHandler from '../__header/header';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import vhUnit, { headerHeightVar, vhUnitMobileResize } from '../__utils/vhUnit';
import blockResizeAnimation from '../__utils/blockResizeAnimation';
import detectDevice from '../__utils/detectDevice';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        alertBar();
        vhUnit();
        headerHeightVar();
        vhUnitMobileResize();
        // MegaMenu.init();
        headerHandler.init();
        Accordion.init();
        Video.init();
        mirrorHover();
        smoothScroll();
        Tables.init();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        Forms();
        vhUnit();
        headerHeightVar();
        vhUnitMobileResize();
        Forms();
    },
    resized() {
        // headerMobile.resized();
        Tables.toggleShadow();
        headerHeightVar();
        vhUnitMobileResize();
        blockResizeAnimation();
        headerHandler.transparentStateHandler();
        alertBarResize();

        if (
            !detectDevice.isPhone() &&
            !detectDevice.isTablet() &&
            !detectDevice.isIpadOS()
        ) {
            vhUnit();
        }
    },
    scrolled() {
        headerHandler.transparentStateHandler();
    },
    keyDown(e) {},
    mouseUp(e) {
        // headerMobile.hideOutsideClick(e);
        headerHandler.hideOutSideClick(e);
    },
    orientationChange() {
        if (
            detectDevice.isPhone() ||
            detectDevice.isTablet() ||
            detectDevice.isIpadOS()
        ) {
            const afterOrientationChange =
                function fireAfterOrientationChange() {
                    vhUnit();
                    window.removeEventListener(
                        'resize',
                        afterOrientationChange
                    );
                };
            window.addEventListener('resize', afterOrientationChange);
        }
    },
    gformRender() {
        Forms();
    },
};
export default controller;
